import { BsClipboard2CheckFill, BsLockFill } from 'react-icons/bs';
import { useRegulatoryTrainingMatrix } from '@/hooks/useNewRegulatoryTrainingMatrix';
import { NewRegulatoryTrainingMatrixCellData } from '@/types/NewRegulatoryTrainingData';
import LightTooltip from '../atoms/LightTooltip';
import { Checkbox } from '../ui/checkbox';

interface NewRegulatoryTrainingMatrixCellProps {
	cell: NewRegulatoryTrainingMatrixCellData;
}

export const NewRegulatoryTrainingMatrixCell = ({
	cell,
}: NewRegulatoryTrainingMatrixCellProps) => {
	const {
		editions: { isOnEditionMode, setEditions, editions },
		permissions: { userIsAllowedToCheck, userIsAllowedToBlock },
	} = useRegulatoryTrainingMatrix();

	const isChecked = editions[cell.id]?.checked ?? cell.checked;
	const isBlockChecked = editions[cell.id]?.blockChecked ?? cell.blockChecked;

	const handleToggleChecked = () => {
		const newChecked = !isChecked;
		const newEditions = { ...editions };
		if (editions[cell.id]) {
			newEditions[cell.id] = { ...newEditions[cell.id], checked: newChecked };
		} else {
			newEditions[cell.id] = {
				id: cell.id,
				checked: newChecked,
				blockChecked: isBlockChecked,
			};
		}
		setEditions(newEditions);
	};

	const handleToggleBlockChecked = () => {
		const newBlockChecked = !isBlockChecked;
		const newEditions = { ...editions };
		if (editions[cell.id]) {
			newEditions[cell.id] = {
				...newEditions[cell.id],
				blockChecked: newBlockChecked,
			};
		} else {
			newEditions[cell.id] = {
				id: cell.id,
				checked: isChecked,
				blockChecked: newBlockChecked,
			};
		}
		setEditions(newEditions);
	};
	return (
		<div className="w-full flex items-center justify-center gap-4">
			<div className="w-12 ">
				{isOnEditionMode ? (
					<div className="flex gap-2 items-center">
						<Checkbox
							className="w-4 h-4"
							checked={isChecked}
							onCheckedChange={handleToggleChecked}
							disabled={isBlockChecked || !userIsAllowedToCheck}
						/>
						<BsClipboard2CheckFill size={18} color="#00d692" />
					</div>
				) : (
					isChecked && (
						<LightTooltip title="Mapeado">
							<div>
								<BsClipboard2CheckFill size={18} color="#00d692" />
							</div>
						</LightTooltip>
					)
				)}
			</div>
			<div className="w-12">
				{isOnEditionMode ? (
					<div className="flex gap-2 items-center">
						<Checkbox
							className="w-4 h-4"
							checked={isBlockChecked}
							onCheckedChange={handleToggleBlockChecked}
							disabled={!isChecked || !userIsAllowedToBlock}
						/>
						<BsLockFill size={18} color="#f4503a" />
					</div>
				) : (
					isBlockChecked && (
						<LightTooltip title="Mapeado para bloqueio de catraca">
							<div>
								<BsLockFill size={18} color="#f4503a" />
							</div>
						</LightTooltip>
					)
				)}
			</div>
		</div>
	);
};
